enum OperatingSystem {
	IOS = 'iOS',
	ANDROID = 'Android OS',
}

enum BrowserName {
	FIREFOX = 'firefox',
	SAFARI = 'safari',
	CHROME = 'chrome',
}

export {OperatingSystem, BrowserName};
